<template>
    <div class="p-grid">
        <div class="p-col-12 p-pt-2 p-pb-0">
            <div class="p-grid p-ai-center p-pt-1 vertical-container">
                <div class="p-col-fixed" style="width: 55px">
                    <a @click="$functions.historyBack()" style="cursor: pointer">
                        <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')"/>
                    </a>
                </div>
                <div v-if="appliance" class="p-col">
                    <h3>{{ appliance.name ?? $functions.fixModelName(appliance.modelNumber) }} - {{ $t('details.buttons.analytics_button') }} <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')" /> {{ $t('analytics.' + idChart) }}</h3>
                </div>
                <div v-else class="p-col">
                    <h3>{{ lab.name }} - {{ $t('details.buttons.analytics_button') }} <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')" /> {{ $t('analytics.' + idChart) }}</h3>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-pb-0">
                    <div class="irinox-form">
                        <div class="p-formgroup-inline p-ai-center">
                            <div class="p-field">
                                <Dropdown :id="idChart" v-model="selectedPeriod[chartType]" :options="periodData[chartType]" optionLabel="name" optionValue="code" :placeholder="$t('analytics.period')" @change="changePeriod" />
                            </div>
                            <div class="p-field">
                                <Calendar v-model="valueCalendar" :showIcon="true" dateFormat="yy-mm-dd" selectionMode="range" :minDate="minDate" :maxDate="maxDate" :manualInput="false" :placeholder="$t('analytics.range_date')" @date-select="changeCalendarRange" />
                            </div>
                            <!-- <div v-if="!appliance" class="p-field">
                                <Dropdown  id="gamma" v-model="selectedGamma" :options="gamme" optionLabel="name" optionValue="code" :placeholder="$t('factory.appliances.filter_gamma_ph')" />
                            </div> -->
                        </div>
                    </div>
                    <div class="single-chart card">
                      <div class="single-chart-container">
                        <Chart v-if="chartLoaded && adminChart" :ref="idChart" :key="idChart" :id="idChart" :type="adminChart.type" :data="$functions.extractChartData(adminChart)" :options="$functions.extractChartOptions(adminChart)" :class="[adminChart.type]" />
                        <Skeleton v-else-if="!chartLoaded && !adminChart" ></Skeleton>
                        <div v-else>{{ $t('analytics.no_data_period') }}</div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <IrinoxDialogDark :visible="dialog.blockingError" mode="error" :message="$t('userinfo.error_dialog')" :life="3000" @update:visible="dialog.blockingError = $event" />
</template>


<script>
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import AnalyticsService from '../../service/AnalyticsService';
import { mapGetters } from 'vuex';
import 'chartjs-adapter-moment';
import ApplianceService from '../../service/ApplianceService';

export default {
    components: {
        IrinoxDialogDark,
    },
    data() {
        return {
            valueCalendar: [],
            minDate: null,
            maxDate: null,
            selectedPeriod: {
                bar: 7,
                doughnut: 7,
                line: 1,
            },
            periodData: {
                bar: [
                    { name: this.$t('analytics.period_last_w'), code: 7 },
                    { name: this.$t('analytics.period_last_1m'), code: 30 },
                ],
                doughnut: [
                    { name: this.$t('analytics.period_last_d'), code: 1 },
                    { name: this.$t('analytics.period_last_w'), code: 7 },
                    { name: this.$t('analytics.period_last_1m'), code: 30 },
                ],
                line: [
                    { name: this.$t('analytics.period_last_d'), code: 1 },
                    { name: this.$t('analytics.period_last_w'), code: 7 },
                    // { name: this.$t('analytics.period_last_1m'), code: 30 },
                ],
            },
            // gamme: null,
            selectedGamma: this.$route.params.gamma,
            serialNumber: this.$route.params.serialNumber,
            labId: this.$route.params.labId,
            idChart: this.$route.params.idChart,
            chartType: this.$route.params.chartType,
            analyticsService: null,
            chartsOptions: {
                bar: {
                    animation: false,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057',
                            },
                        },
                    },
                    scales: {
                        x: {
                            ticks: {
                                color: '#495057',
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                        y: {
                            ticks: {
                              color: '#495057'
                            },
                            grid: {
                                color: '#ebedef',
                            },
                            title: {
                                display: false,
                                text: '',
                            },
                        },
                    },
                },
                doughnut: {
                    animation: false,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057',
                            },
                        },
                    },
                },
                line: {
                    animation: false,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057',
                            },
                        },
                        // decimation: {
                        //     enabled: true,
                        //     algorithm: 'lttb',
                        //     samples: 50
                        // },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'YYYY/MM/DD',
                                },
                            },
                            ticks: {
                                color: '#495057',
                                callback: function (value) {
                                    return this.$d(new Date(value), 'shortNumeric');
                                }.bind(this),
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                        y: {
                            title: {
                                display: true,
                                text: '°C',
                            },
                            ticks: {
                                color: '#495057',
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                    },
                },
                stepped: {
                    animation: false,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057',
                            },
                        },
                        // decimation: {
                        //     enabled: true,
                        //     algorithm: 'lttb',
                        //     samples: 50
                        // },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'YYYY/MM/DD',
                                },
                            },
                            ticks: {
                                color: '#495057',
                                callback: function (value) {
                                    return this.$d(new Date(value), 'shortNumeric');
                                }.bind(this),
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                        y: {
                            title: {
                                display: true,
                                text: '°C',
                            },
                            ticks: {
                                color: '#495057',
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                    },
                },
            },
            adminRemoteChart: null,
            chartLoaded: false,
            adminChart: null,
            dialog: {
                blockingError: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            personaltoken: 'userdata/personaltoken',
            role: 'userdata/role',
            is24hour: 'userdata/is24hour',
        }),
        appliance: function () {
            if (this.serialNumber) {
                return this.$store.getters['appliances/appliance'](this.serialNumber);
            } else {
                return null;
            }
        },
        lab: function () {
            if (this.labId) {
                return this.$store.getters['appliances/lab'](this.labId);
            } else {
                return null;
            }
        },
    },
    created() {
        this.analyticsService = new AnalyticsService();
        this.applianceService = new ApplianceService();
        let today = new Date();
        let month = today.getMonth();
        let prevMonth = month - 1;
        this.minDate = new Date();
        this.minDate.setMonth(prevMonth);
        this.maxDate = new Date();
    },
    mounted() {
        // if (this.labId) {
        //     this.getGamme();
        // }
        let startDate = this.dateToStringFormat(this.$moment().subtract(this.selectedPeriod[this.chartType], 'days'), 'YYYY-MM-DD');
        let endDate = this.dateToStringFormat(this.$moment(), 'YYYY-MM-DD');
        this.valueCalendar.push(this.$moment().subtract(this.selectedPeriod[this.chartType], 'days').toDate())
        this.valueCalendar.push(this.$moment().toDate())
        this.getChartsById(startDate, endDate);
    },
    methods: {
        dynamicColors(index) {
            // var r = Math.floor(Math.random() * 255);
            // var g = Math.floor(Math.random() * 255);
            // var b = Math.floor(Math.random() * 255);
            // return ['rgb(' + r + ',' + g + ',' + b + ')', 'rgb(' + r + ',' + g + ',' + b + ', 0.8)'];
            return this.$functions.getColorByIdFromPalette(index);
        },
        dateToStringFormat(dateValue, stringFormat) {
            return this.$moment(dateValue).format(stringFormat);
        },
        changeCalendarRange() {
            if (this.valueCalendar && this.valueCalendar[0] && this.valueCalendar[1]) {
                let startDate = this.dateToStringFormat(this.$moment(this.valueCalendar[0]), 'YYYY-MM-DD');
                let endDate = this.dateToStringFormat(this.$moment(this.valueCalendar[1]), 'YYYY-MM-DD');
                this.getChartsById(startDate, endDate);
            }
        },
        changePeriod() {
            let startDate = this.dateToStringFormat(this.$moment().subtract(this.selectedPeriod[this.chartType], 'days'), 'YYYY-MM-DD');
            let endDate = this.dateToStringFormat(this.$moment(), 'YYYY-MM-DD');
            this.getChartsById(startDate, endDate);
        },
        // getGamme() {
        //     this.applianceService
        //         .getGammeByLab(this.personaltoken, this.labId)
        //         .then((gammeData) => {
        //             // TODO manipulation
        //             if (gammeData.length > 0) {
        //                 this.gamme = [];
        //                 gammeData.forEach((gammacode) => {
        //                     this.gamme.push({ code: gammacode, name: gammacode });
        //                 });
        //                 this.gamme.sort((a, b) => this.$functions.compareStrings(a, b, "name"));
        //             }
        //         })
        //         .catch((error) => {
        //             console.error('EXCEPTION ' + error);
        //             this.dialog.blockingError = true;
        //         });
        // },
        getChartsById(startDate, endDate) {
            this.chartLoaded = false;
            this.adminChart = null;
            if (this.serialNumber) {

                if (this.role != "USER") {
                    this.analyticsService
                        .getServiceChartsById(this.personaltoken, this.serialNumber, startDate, endDate, this.idChart)
                        .then((chart) => {
                            if (chart.body && chart.code == "200") {
                                this.adminRemoteChart = chart.body;
                                this.populateChart(startDate, endDate);
                            } else {
                                console.error('EXCEPTION');
                                this.chartloaded = true;
                            }
                        })
                        .catch((error) => {
                            console.error('EXCEPTION ' + error);
                            this.dialog.blockingError = true;
                            this.chartLoaded = true;
                        });
                } else {
                    this.analyticsService
                        .getAdminChartsById(this.personaltoken, this.serialNumber, startDate, endDate, this.idChart)
                        .then((chart) => {
                            if (chart.body && chart.code == "200") {
                                this.adminRemoteChart = chart.body;
                                this.populateChart(startDate, endDate);
                            } else {
                                console.error('EXCEPTION');
                                this.chartloaded = true;
                            }
                        })
                        .catch((error) => {
                            console.error('EXCEPTION ' + error);
                            this.dialog.blockingError = true;
                            this.chartloaded = true;
                        });
                }

            } else {
                this.analyticsService
                    .getLabChartsById(this.personaltoken, this.labId, startDate, endDate, this.selectedGamma, this.idChart)
                    .then((chart) => {
                        if (chart.body && chart.code == "200") {
                            this.adminRemoteChart = chart.body;
                            this.populateLabChart();
                        } else {
                            console.error('EXCEPTION');
                            this.chartloaded = true;
                        }
                    })
                    .catch((error) => {
                        console.error('EXCEPTION ' + error);
                        this.dialog.blockingError = true;
                        this.chartloaded = true;
                    });
            }
        },
        ticksCallback(value) {
            // fa tipo questo, ma non impostando lo stepSize ma settando il numero natuale (this.adminChart.chartOpt.scales.y.ticks.stepSize = 1;)
            if (Math.floor(value) === value) {
                return value;
            }
        },
        populateChart(startDate, endDate) {
            /**
             * state_1
             * cycle_1
             * state_2
             * cycle_2
             * temperature_1
             * humidity_1
             * humidity_2
             * 
             * t_ambient
             * t_cell
             * t_condenser_1
             * t_condenser_2
             * level_humidity_1
             * level_humidity_2
             * percentage
             * percentage_grouped
             * sanigen
             * evap_state
             * heating_res_state
             * compressor_state
             * door_res_state
             * light_state
             * door_counter
             * door_time
             * heating_res_time
             * door_res_time
             * compressor_time
             * defrost_time
             * light_time
             * cycle_1
             * state_1
             */
            if (this.adminRemoteChart.datasets != null && this.adminRemoteChart.datasets.length>0 && this.adminRemoteChart.labels != null) {
                this.adminChart = this.adminRemoteChart;

                let chartOpt = this.$functions.clone(this.chartsOptions[this.adminChart.type]);
                this.adminChart.chartOpt = chartOpt;

                if (this.adminChart.type == 'doughnut') {
                    this.adminChart.datasets[0].data.forEach((dataDoughnut, indexDoughnut) => {
                        if (!this.adminChart.datasets[0].backgroundColor) {
                            this.adminChart.datasets[0].backgroundColor = [];
                        }
                        if (!this.adminChart.datasets[0].hoverBackgroundColor) {
                            this.adminChart.datasets[0].hoverBackgroundColor = [];
                        }
                        // let dynamicColors = this.dynamicColors();
                        this.adminChart.datasets[0].backgroundColor[indexDoughnut] = this.dynamicColors(indexDoughnut);
                        this.adminChart.datasets[0].hoverBackgroundColor[indexDoughnut] = this.dynamicColors(indexDoughnut);
                    });
                    if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MF Next') {
                        switch (this.adminChart.id) {
                            case 'state_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('mf.functions.' + label);
                                });
                                break;
                            case "door_time":
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t("details.mf.door_active_" + label);
                                });
                                break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MYA') {
                        switch (this.adminChart.id) {
                            case 'state_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('mya.functions.' + label);
                                });
                                break;
                            case 'cycle_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('mya.cycles.' + label.split('_')[1]);
                                });
                                break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'CONSERVATORE') {
                        switch (this.adminChart.id) {
                            case 'state_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('details.cp.mode_' + label);
                                });
                                break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'FERMALIEVITA') {
                        switch (this.adminChart.id) {
                            case "state_1":
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('analytics.mp.' + label);
                                });
                                break;
                            case "door_time":
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t("details.mp.door_active_" + label);
                                });
                                break;
                            default:
                                break;

                        }
                    }
                } else if (this.adminChart.type == 'bar') {

                    this.adminChart.datasets.forEach((dataBar, indexData) => {
                        dataBar.backgroundColor = this.dynamicColors(indexData);
                    });
                    this.adminChart.labels.forEach((labelDate, indexLabelDate) => {
                        this.adminChart.labels[indexLabelDate] = this.$d(labelDate, 'shortNumeric');
                    });
                    if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MF Next') {
                        switch (this.adminChart.id) {
                            case 'state_2':
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('mf.functions.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.scales.y.title.display = true;
                                this.adminChart.chartOpt.scales.y.title.text = this.adminChart.unit;
                                break;
                            case 'cycle_2':
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MYA') {
                        switch (this.adminChart.id) {
                            case 'state_2':
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('mya.functions.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.scales.y.title.display = true;
                                this.adminChart.chartOpt.scales.y.title.text = this.adminChart.unit;
                                break;
                            case 'cycle_2':
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('mya.cycles.' + dataset.label.split('_')[1]);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            case 'defrost_time':
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t("extra.mya.status." + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                this.adminChart.chartOpt.scales.y.title.display = true;
                                this.adminChart.chartOpt.scales.y.title.text = this.adminChart.unit;
                                break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'CONSERVATORE') {
                        switch (this.adminChart.id) {
                            // case "door_counter":
                            //     this.adminChart.datasets.forEach((dataset, indexDataset) => {
                            //         this.adminChart.datasets[indexDataset].label = this.$t('extra.cp.status.' + dataset.label);
                            //     });
                            //     this.adminChart.chartOpt.scales.y.beginAtZero = true;
                            //     this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                            //     break;
                            case 'state_2':
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('details.cp.mode_' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.scales.y.title.display = true;
                                this.adminChart.chartOpt.scales.y.title.text = this.adminChart.unit;
                                break;
                            case 'cycle_2':
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            case 'defrost_time':
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t("extra.cp.status." + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                this.adminChart.chartOpt.scales.y.title.display = true;
                                this.adminChart.chartOpt.scales.y.title.text = this.adminChart.unit;
                                break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'FERMALIEVITA') {
                        switch (this.adminChart.id) {
                            // case "door_counter":
                            // case "percentage_grouped":
                            //     this.adminChart.datasets.forEach((dataset, indexDataset) => {
                            //         this.adminChart.datasets[indexDataset].label = this.$t('extra.mp.status.' + dataset.label);
                            //     });
                            //     break;
                            case "state_2":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.mp.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.scales.y.title.display = true;
                                this.adminChart.chartOpt.scales.y.title.text = this.adminChart.unit;
                                break;
                            case 'cycle_2':
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            default:
                                break;

                        }
                    }
                } else if (this.adminChart.type == 'line') {

                    this.adminChart.chartOpt.scales.y.title.text = this.adminChart.unit;

                    if(endDate.replace(/-/g,"") - startDate.replace(/-/g,"") <= 1) {
                      this.adminChart.chartOpt.scales.x.time = {
                        unit: 'hour',
                        displayFormats: {
                            hour: 'HH.mm',
                        },
                      }
                    }

                    this.adminChart.datasets.forEach((valueDataset, indexDataset) => {
                        let series = [];
                        this.adminChart.datasets[indexDataset].data.forEach((valueY, indexValueY) => {
                            series.push({
                                x: this.adminChart.labels[indexValueY],
                                y: valueY,
                            });
                        });
                        this.adminChart.datasets[indexDataset].data = series;
                    });

                    if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MF Next') {
                        switch (this.adminChart.id) {
                            case "percentage":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.mf.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_ambient":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.mf.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_cell":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.mf.status.' + dataset.label);
                                });
                                break;
                            case "t_condenser_1":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.mf.status.' + dataset.label);
                                });
                                break;
                            case "t_evaporator":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.mf.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MYA') {
                        switch (this.adminChart.id) {
                            case "percentage":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.mya.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_cell":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.mya.status.' + dataset.label);
                                });
                                break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'FERMALIEVITA') {
                        switch (this.adminChart.id) {
                            case "percentage":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.mp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_ambient":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.mp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_cell":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.mp.status.' + dataset.label);
                                });
                                break;
                            case "t_condenser_1":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.mp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_evaporator":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.mp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "level_humidity_2":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.mp.status.' + dataset.label);
                                });
                                break;
                            // case "temperature_1":
                            // case "compressor_state":
                            // case "heating_res_state":
                            // case "door_res_state":
                            // case "level_humidity_1":
                            // case "level_humidity_2":
                            // case "t_condenser_2":
                            // case "sanigen":
                            // case "evap_state":
                            // case 'humidity_2':
                            //     this.adminChart.datasets.forEach((dataset, indexDataset) => {
                            //         this.adminChart.datasets[indexDataset].label = this.$t('extra.mp.status.' + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;
                        }
                    } else if (this.appliance.type == 'CONSERVATORE') {
                        switch (this.adminChart.id) {
                            case "percentage":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.cp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            // case 'temperature_1':
                            case 't_condenser_1':
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.cp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_cell":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.cp.status.' + dataset.label);
                                });
                                break;
                            case "t_evaporator":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('extra.cp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            default:
                                break;
                        }
                    }
                    this.adminChart.datasets.forEach((dataLine, indexData) => {
                        dataLine.borderColor = this.dynamicColors(indexData);
                        dataLine.fill = false;
                        // dataLine.tension = 0.4;
                    });
                } else if (this.adminChart.type == 'stepped') {
                    this.adminChart.type = "line";

                    let chartOpt = this.$functions.clone(this.chartsOptions[this.adminChart.type]);
                    this.adminChart.chartOpt = chartOpt;

                    this.adminChart.chartOpt.scales.y.title.text = this.adminChart.unit;
                    
                    if(endDate.replace(/-/g,"") - startDate.replace(/-/g,"") <= 1) {
                      this.adminChart.chartOpt.scales.x.time = {
                        unit: 'hour',
                        displayFormats: {
                            hour: 'HH.mm',
                        },
                      }
                    }

                    this.adminChart.datasets.forEach((valueDataset, indexDataset) => {
                        let series = [];
                        this.adminChart.datasets[indexDataset].data.forEach((valueY, indexValueY) => {
                            series.push({
                                x: this.adminChart.labels[indexValueY],
                                y: valueY,
                            });
                        });
                        this.adminChart.datasets[indexDataset].data = series;
                    });

                    if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MF Next') {
                        switch (this.adminChart.id) {
                            case "sanigen":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t("extra.mf.status." + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            // case "compressor_state":
                            // case "heating_res_state":
                            // case "door_res_state":
                            // case "evap_state":
                            //     this.adminChart.datasets.forEach((dataset, indexDataset) => {
                            //         this.adminChart.datasets[indexDataset].label = this.$t("extra.mf.status." + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MYA') {
                        switch (this.adminChart.id) {
                            case "sanigen":
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            // case "heating_res_state":
                            // case "compressor_state":
                            // case "door_res_state":
                            // case "evap_state":
                            //     this.adminChart.datasets.forEach((dataset, indexDataset) => {
                            //         this.adminChart.datasets[indexDataset].label = this.$t("extra.mya.status." + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'FERMALIEVITA') {
                        switch (this.adminChart.id) {
                            case "sanigen":
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            case "level_humidity_1":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.mp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            // case "temperature_1":
                            // case "compressor_state":
                            // case "heating_res_state":
                            // case "door_res_state":
                            // case "evap_state":
                            // case "level_humidity_1":
                            // case "light_state":
                            // case "t_cell":
                            // case "humidity_1":
                            // case "humidity_2":
                            //     this.adminChart.datasets.forEach((dataset, indexDataset) => {
                            //         this.adminChart.datasets[indexDataset].label = this.$t("extra.mp.status." + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'CONSERVATORE') {
                        switch (this.adminChart.id) {
                            // case "sanigen":
                            //     this.adminChart.datasets.forEach((dataset, indexDataset) => {
                            //         this.adminChart.datasets[indexDataset].label = this.$t('extra.cp.status.' + dataset.label);
                            //     });
                            //     this.adminChart.chartOpt.scales.y.beginAtZero = true;
                            //     this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                            //     this.adminChart.chartOpt.plugins.legend.display = false;
                            //     break;
                            case "level_humidity_1":
                                this.adminChart.datasets.forEach((dataset, indexDataset) => {
                                    this.adminChart.datasets[indexDataset].label = this.$t('analytics.cp.status.' + dataset.label);
                                });
                                this.adminChart.chartOpt.scales.y.beginAtZero = true;
                                this.adminChart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.adminChart.chartOpt.plugins.legend.display = false;
                                break;
                            // case "light_state":
                            // case "evap_state":
                            // case 'door_res_state':
                            // case "level_humidity_1":
                            // case "compressor_state":
                            // case 'humidity_1':
                            //     this.adminChart.datasets.forEach((dataset, indexDataset) => {
                            //         this.adminChart.datasets[indexDataset].label = this.$t('extra.cp.status.' + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;
                        }
                    }
                    this.adminChart.datasets.forEach((dataLine, indexData) => {
                        dataLine.borderColor = this.dynamicColors(indexData);
                        dataLine.fill = false;
                        // dataLine.tension = 0.4;
                        dataLine.stepped = "before";
                    });
                }
            }
            this.chartLoaded = true;
        },
        populateLabChart() {
            /**
             * state_1
             * cycle_1
             */
            if (this.adminRemoteChart.datasets != null && this.adminRemoteChart.labels != null) {
                this.adminChart = this.adminRemoteChart;

                let chartOpt = this.$functions.clone(this.chartsOptions[this.adminChart.type]);
                this.adminChart.chartOpt = chartOpt;

                if (this.adminChart.type == 'doughnut') {
                    this.adminChart.datasets[0].data.forEach((dataDoughnut, indexDoughnut) => {
                        if (!this.adminChart.datasets[0].backgroundColor) {
                            this.adminChart.datasets[0].backgroundColor = [];
                        }
                        if (!this.adminChart.datasets[0].hoverBackgroundColor) {
                            this.adminChart.datasets[0].hoverBackgroundColor = [];
                        }
                        // let dynamicColors = this.dynamicColors();
                        this.adminChart.datasets[0].backgroundColor[indexDoughnut] = this.dynamicColors(indexDoughnut);
                        this.adminChart.datasets[0].hoverBackgroundColor[indexDoughnut] = this.dynamicColors(indexDoughnut);
                    });
                    if (this.selectedGamma == 'MF Next') {
                        switch (this.adminChart.id) {
                            case 'state_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('mf.functions.' + label);
                                });
                                break;
                            case 'cycle_1':
                                console.log('cycle 1 doughnut');
                                break;
                            default:
                                break;
                        }
                    } else if (this.selectedGamma == 'MYA') {
                        switch (this.adminChart.id) {
                            case 'state_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('mya.functions.' + label);
                                });
                                break;
                            case 'cycle_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('mya.cycles.' + label.split('_')[1]);
                                });
                                break;
                            default:
                                break;
                        }
                    } else if (this.selectedGamma == 'MP Next') {
                        switch (this.adminChart.id) {
                            case 'state_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('details.mp.' + label);
                                });
                                break;
                            default:
                                break;
                        }
                    } else {
                        switch (this.adminChart.id) {
                            case 'state_1':
                                this.adminChart.labels.forEach((label, indexLabel) => {
                                    this.adminChart.labels[indexLabel] = this.$t('details.cp.mode_' + label);
                                });
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
            this.chartLoaded = true;
        },
    },
};
</script>
<style scoped>

h3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
/* 
.single-chart {
    display: flex;
} */

.single-chart-container {
  margin: auto;
  width: 100%;
  display: flex;
    justify-content: center;
}
.p-chart {
  min-height: 400px;
  height: calc(100vh - 350px);
}
.p-chart {
    width: 100%;
}
.p-chart.doughnut {
    width: calc(100vh - 350px);
}

.p-skeleton {
  padding-top: calc(100vh - 350px);
}

</style>